[
  {
    "code": "VC-01",
    "name": "Charlotte"
  },
  {
    "code": "VC-06",
    "name": "Grenadines"
  },
  {
    "code": "VC-02",
    "name": "Saint Andrew"
  },
  {
    "code": "VC-03",
    "name": "Saint David"
  },
  {
    "code": "VC-04",
    "name": "Saint George"
  },
  {
    "code": "VC-05",
    "name": "Saint Patrick"
  }
]